import type {UseQueryResult} from '@tanstack/react-query';
import {useQuery} from '@tanstack/react-query';
import useApiFetch from '@/components/MSAL/useApiFetch';
import type {Employee} from '@/types/Employee';
import {apiUrl} from '@/utils/api';

export const useGetSelf = () : UseQueryResult<Employee> => {
    const fetch = useApiFetch();

    return useQuery(['self'], async ({signal}) => {
        const response = await fetch(apiUrl('/v1/scheduler/employees/self').toString(), {signal});

        if (!response.ok) {
            throw new Error('Unable to fetch self employee record.');
        }

        return (await response.json()) as Employee;
    });
};
